import { render, staticRenderFns } from "./ViewLogin.vue?vue&type=template&id=36bd8249&scoped=true"
import script from "./ViewLogin.vue?vue&type=script&lang=js"
export * from "./ViewLogin.vue?vue&type=script&lang=js"
import style0 from "./ViewLogin.vue?vue&type=style&index=0&id=36bd8249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd8249",
  null
  
)

export default component.exports